<script setup lang="ts">
import SubmitAnimation from "./SubmitAnimation.vue";

const props = defineProps({
  success: {
    type: Boolean,
  },
  error: {
    type: Boolean,
  },
});
</script>

<template>
  <div
    class="form-success"
    role="alertdialog"
    aria-labelledby="submittingTitle"
    aria-describedby="submittingMessage"
  >
    <h2 v-show="props.success" id="submittingTitle">
      <slot name="title" />
    </h2>
    <h2 v-show="!props.success">Submitting ...</h2>
    <div v-if="!error" class="success-icon">
      <SubmitAnimation :is-animating="!props.success" />
    </div>
    <p v-show="props.success" id="submittingMessage">
      <slot name="message" />
    </p>
    <p v-show="!props.success"></p>
  </div>
</template>

<style lang="scss" scoped>
@use "@/assets/scss/queries";
.form-success {
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 3rem;
  text-align: center;
  width: 100%;
  h2 {
    font-size: 4.5rem !important;
    margin-bottom: 0;

    @include queries.for-size(desktop-up) {
      max-width: 800px;
    }

    @include queries.for-size(phone-only) {
      font-size: 3rem !important;
    }
  }
  p {
    color: black !important;
    font-size: 3rem !important;
  }
}
</style>
